const defaultPublicDomain = "doteb.com";

function readEnv(...names: string[]): string | undefined {
	if (typeof process === "undefined") {
		return undefined;
	}
	for (const name of names) {
		const value = process.env[name]?.trim();
		if (value) {
			return value;
		}
	}
	return undefined;
}

function normalizePath(path = ""): string {
	if (!path) {
		return "";
	}
	return path.startsWith("/") ? path : `/${path}`;
}

function cleanUrl(url: string): string {
	return url.replace(/\/+$/, "");
}

function publicDomain(): string {
	return (
		readEnv(
			"PUBLIC_DOMAIN",
			"NEXT_PUBLIC_DOMAIN",
			"NEXT_PUBLIC_PUBLIC_DOMAIN",
		) ?? defaultPublicDomain
	)
		.replace(/^https?:\/\//, "")
		.replace(/\/.*$/, "");
}

function publicSubdomain(subdomain: string): string {
	return `https://${subdomain}.${publicDomain()}`;
}

export function getMarketingUrl(path = ""): string {
	return (
		cleanUrl(
			readEnv("PUBLIC_URL", "APP_URL", "UI_URL", "NEXT_PUBLIC_APP_URL") ??
				`https://${publicDomain()}`,
		) + normalizePath(path)
	);
}

export function getDocsUrl(path = ""): string {
	return (
		cleanUrl(
			readEnv("PUBLIC_DOCS_URL", "DOCS_URL", "NEXT_PUBLIC_DOCS_URL") ??
				publicSubdomain("docs"),
		) + normalizePath(path)
	);
}

export function getApiUrl(path = ""): string {
	return (
		cleanUrl(
			readEnv("PUBLIC_API_URL", "API_URL", "NEXT_PUBLIC_API_URL") ??
				publicSubdomain("api"),
		) + normalizePath(path)
	);
}

export function getChatUrl(path = ""): string {
	return (
		cleanUrl(
			readEnv(
				"PUBLIC_CHAT_URL",
				"CHAT_URL",
				"PLAYGROUND_URL",
				"NEXT_PUBLIC_CHAT_URL",
			) ?? publicSubdomain("chat"),
		) + normalizePath(path)
	);
}

export function getContactEmail(): string {
	return (
		readEnv("CONTACT_EMAIL", "NEXT_PUBLIC_CONTACT_EMAIL") ??
		`contact@${publicDomain()}`
	);
}

export function getStatusUrl(path = ""): string {
	return (
		cleanUrl(
			readEnv("PUBLIC_STATUS_URL", "STATUS_URL", "NEXT_PUBLIC_STATUS_URL") ??
				publicSubdomain("status"),
		) + normalizePath(path)
	);
}
